'use strict';

namespace Core.Customer {

    import TripStage = Core.ManageBooking.TripStage;

    export enum CurrentTripType {
        Flight = 1,
        Hotel,
        Holiday
    }

    class CurrentTripCard {

        private titles = {
            Holiday: {
                PreTrip: {
                    Days: 'CURRENTTRIP_HOLIDAY_STARTSINXDAYS',
                    Tomorrow: 'CURRENTTRIP_HOLIDAY_STARTSTOMORROW',
                    Today: 'CURRENTTRIP_HOLIDAY_STARTSTODAY'
                },
                OnTrip: {
                    Days: 'CURRENTTRIP_HOLIDAY_ENDSINXDAYS',
                    Tomorrow: 'CURRENTTRIP_HOLIDAY_ENDSTOMORROW',
                    Today: 'CURRENTTRIP_HOLIDAY_ENDSTODAY'
                }
            },
            Hotel: {
                PreTrip: {
                    Days: 'CURRENTTRIP_HOTEL_STARTSINXDAYS',
                    Tomorrow: 'CURRENTTRIP_HOTEL_STARTSTOMORROW',
                    Today: 'CURRENTTRIP_HOTEL_STARTSTODAY'
                },
                OnTrip: {
                    Days: 'CURRENTTRIP_HOTEL_ENDSINXDAYS',
                    Tomorrow: 'CURRENTTRIP_HOTEL_ENDSTOMORROW',
                    Today: 'CURRENTTRIP_HOTEL_ENDSTODAY'
                }
            }
            ,
            Flight: {
                PreTrip: {
                    Days: 'CURRENTTRIP_FLIGHT_STARTSINXDAYS',
                    Tomorrow: 'CURRENTTRIP_FLIGHT_STARTSTOMORROW',
                    Today: 'CURRENTTRIP_FLIGHT_STARTSTODAY'
                },
                OnTrip: {
                    Days: 'CURRENTTRIP_FLIGHT_ENDSINXDAYS',
                    Tomorrow: 'CURRENTTRIP_FLIGHT_ENDSTOMORROW',
                    Today: 'CURRENTTRIP_FLIGHT_ENDSTODAY'
                }
            }
        };

        // Attr
        trip: ManageBooking.BookedTrip;

        private flightLegsToDisplay: ManageBooking.FlightLeg[] = [];
        private showExtraProducts: boolean = false;
        private cardTitle: string;

        private tripType: CurrentTripType;

        constructor (
            private $scope: ng.IScope,
            private resourceService: any
        ) {
        }

        init (): void {
            if (this.trip.FlightBooking && this.trip.HotelBooking) {
                this.tripType = CurrentTripType.Holiday;
            } else {
                this.tripType = this.trip.HotelBooking ? CurrentTripType.Hotel : CurrentTripType.Flight;
            }

            if (this.trip.FlightBooking) {
                if (this.trip.TripStage === TripStage.PreTrip) {
                    this.flightLegsToDisplay = this.trip.FlightBooking.Legs;
                } else {
                    this.flightLegsToDisplay.push(_.last(this.trip.FlightBooking.Legs));
                }
            }

            if (this.trip.TransferBooking
                || this.trip.CarHireBooking
                || this.trip.AirportParkingBooking
                || this.trip.InsuranceBooking) {
                this.showExtraProducts = true;
            }

            this.cardTitle = this.getTitle();
        }

        private getTitle(): string {

            let tripTypeKey = CurrentTripType[this.tripType];
            let tripStageKey = TripStage[this.trip.TripStage];

            let daysUntil: number =
                this.trip.TripStage === TripStage.PreTrip
                    ? this.trip.DaysUntilDeparture
                    : this.trip.DaysUntilReturn;

            // Days, Tomorrow OR Today
            let durationKey: string = 'Today';

            if (daysUntil > 1) {
                durationKey = 'Days';

            } else if (daysUntil === 1) {
                durationKey = 'Tomorrow';
            } else {
                durationKey = 'Today';
            }

            let resourceKey: string = this.titles[tripTypeKey][tripStageKey][durationKey];
            let title = this.resourceService.getDeferred(resourceKey)();

            if (daysUntil > 1) {
                title = title.replace('{0}', daysUntil);
            }

            return title;
        }
    }
    angular
        .module('core')
        .directive('currentTripCard', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: CurrentTripCard,
                controllerAs: 'ct',
                bindToController: {
                    trip: '='
                },
                templateUrl: 'partials/customer/currenttripcard',
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller : CurrentTripCard
                ) => {
                    controller.init();
                }
            };
        });
}
